/**
 * ------------------------------------------------------------------------
 * Global namespace
 * ------------------------------------------------------------------------
 */

var TORUS = TORUS || {};

export default TORUS;